const fr = {
  "tooltip.block.plot.display_settings": "Paramètres de visualisation du graphique",
  "tooltip.block.plot.link": "Synchroniser la navigation temporelle entre les graphiques",
  "tooltip.block.plot.zoom.reset":
    "Afficher les zooms définis dans les paramètres du graphique. Les graphiques synchronisés vont hériter du même zoom temporel.",
  "tooltip.editor.plot.add_data": "Ajouter des données",
  "tooltip.editor.plot.data_period_range":
    "Ensemble des données accessibles dans le graphique, sans considération de zoom",
  "tooltip.editor.plot.delete_encoding": "Supprimer",
  "tooltip.editor.plot.encoding_zoom":
    "Plage de données affichée par défaut, parmi la plage de données chargées",
  "tooltip.editor.plot.group_axis_by_unit":
    "Les données de même unité apparaîtront sur un unique axe",
  "tooltip.editor.plot.marker_info":
    "Choix de l’information portée par la couleur et la forme du marqueur",
  "tooltip.editor.plot.move_down": "Déplacer vers le bas",
  "tooltip.editor.plot.move_up": "Déplacer vers le haut",
  "tooltip.editor.plot.temporal_sync":
    "Activez cette option pour synchroniser la période temporelle entre les graphiques. Tous les graphiques ayant cette option activée présenteront la même plage de date, et toute navigation dans un graphique sera répercutée dans les autres.",
  "tooltip.editor.plot.thresholds": "Paramètres de seuils",
};

export default fr;
